var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16553 0.349609C2.85711 0.349609 0.165527 2.94905 0.165527 6.14418C0.165527 10.1094 5.53494 15.9307 5.76355 16.1765C5.97827 16.4075 6.35317 16.4071 6.56751 16.1765C6.79612 15.9307 12.1655 10.1094 12.1655 6.14418C12.1655 2.94905 9.47391 0.349609 6.16553 0.349609ZM6.16553 9.05959C4.50098 9.05959 3.14681 7.75174 3.14681 6.14418C3.14681 4.53661 4.50101 3.2288 6.16553 3.2288C7.83004 3.2288 9.18421 4.53665 9.18421 6.14421C9.18421 7.75177 7.83004 9.05959 6.16553 9.05959Z",
    fill: "#808B8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.86ef88fb70720c27dbd87462c0ca6176.svg";
export { ForwardRef as ReactComponent };